import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import chunk from 'lodash/chunk';
import Modal from 'src/components/Modal';
import { isDesktopViewport } from '../../helpers/browser';
import styles from './FeaturedFilterBubble.less';

const MAX_OPTIONS_PER_COLUMN = 7;

class FeaturedFilterBubble extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        value: PropTypes.string.isRequired,
      })
    ).isRequired,
    selectedId: PropTypes.number,
    onSelectionChanged: PropTypes.func,
  };

  state = { isOpen: false };

  componentDidMount() {
    window.document.addEventListener('click', this.handleClose);
  }

  componentWillUnmount() {
    window.document.removeEventListener('click', this.handleClose);
  }

  getSelectedOption() {
    const { options, selectedId } = this.props;

    return options.filter(o => o.id === selectedId)[0] || options[0];
  }

  composeStyle(styleName) {
    return `${styleName}${this.state.isOpen ? '-open' : ''}`;
  }

  handleOptionSelected = option => {
    const { onSelectionChanged } = this.props;

    if (isDesktopViewport()) {
      this.trigger.addEventListener('transitionend', this.handleTransitionEnd);

      const before = this.trigger.offsetWidth;

      this.trigger.style.width = 'auto';
      this.trigger.innerText = option.value;

      const after = this.trigger.offsetWidth;

      this.trigger.style.width = `${before}px`;

      setTimeout(() => {
        this.trigger.style.width = `${after}px`;
      }, 1);
    }

    this.setState({ isOpen: false });

    return onSelectionChanged && onSelectionChanged(option.id);
  };

  handleTriggerClick = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  handleTransitionEnd = () => {
    this.trigger.style.width = 'auto';
    this.trigger.removeEventListener('transitionend', this.handleTransitionEnd);
  };

  handleClose = e => {
    if (
      e.target === this.close ||
      (isDesktopViewport() && e.target !== this.trigger)
    ) {
      this.setState({ isOpen: false });
    }
  };

  renderOptions(options) {
    return options.map((option, index) => {
      const buttonClass = classNames('dna-text-l', 'dna-text-normal', {
        'dna-text-brand': option === this.getSelectedOption(),
      });

      return (
        <button
          key={index}
          className={buttonClass}
          styleName="option"
          onClick={() => this.handleOptionSelected(option)}
        >
          {option.value}
        </button>
      );
    });
  }

  renderModal() {
    const { title, options } = this.props;
    const { isOpen } = this.state;

    return (
      <Modal isOpen={isOpen} shouldCloseOnOverlayClick={false} maintainPosition>
        <div styleName="modal-container">
          <header>
            <h2 className="dna-h2" styleName="modal-title">
              {title}
            </h2>
            <button
              styleName="close"
              ref={c => {
                this.close = c;
              }}
              onClick={this.handleClose}
            >
              Close
            </button>
          </header>
          {this.renderOptions(options)}
        </div>
      </Modal>
    );
  }

  renderBubble() {
    const { options } = this.props;

    return (
      <div styleName="bubble-container">
        {chunk(options, MAX_OPTIONS_PER_COLUMN).map((column, i) => (
          <div key={i} styleName="bubble-option-container">
            {this.renderOptions(column)}
          </div>
        ))}
      </div>
    );
  }

  render() {
    return (
      <div styleName={this.composeStyle('bubble')}>
        <button
          className="dna-h1 dna-text-brand"
          styleName={this.composeStyle('trigger')}
          ref={c => {
            this.trigger = c;
          }}
          onClick={this.handleTriggerClick}
        >
          {this.getSelectedOption().value}
        </button>
        {isDesktopViewport() ? this.renderBubble() : this.renderModal()}
      </div>
    );
  }
}

export default CSSModules(FeaturedFilterBubble, styles);



// WEBPACK FOOTER //
// ./src/components/Home/FeaturedFilterBubble.js